import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/tenderDocument',
    meta: { title: '标书管理' },
    component: Layout,
    redirect: '/tenderDocument/list',
    children: [
      {
        path: 'list',
        meta: { title: '标书管理', activeMenu: '/tenderDocument' },
        component: () => import('@/views/tenderDocument/TenderDocument.vue')
      },
      {
        path: 'detail',
        meta: { title: '标书详情', activeMenu: '/tenderDocument' },
        component: () => import('@/views/tenderDocument/TenderDocumentDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增标书', activeMenu: '/tenderDocument' },
        component: () => import('@/views/tenderDocument/TenderDocumentAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑标书', activeMenu: '/tenderDocument' },
        component: () => import('@/views/tenderDocument/TenderDocumentAdd.vue')
      }

    ]
  }

]
